import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService, TranslationService } from '@spartacus/core';
import { catchError, map, Observable } from 'rxjs';
import { ProductReferencesStatusRequest } from './product-cross-reference.model';
import { failStatus, successStatus } from '../../../../core/models/request-status.model';

@Injectable({
  providedIn: 'root',
})
export class ProductCrossReferenceAdapter {
  constructor(
    private http: HttpClient,
    private occEndPointService: OccEndpointsService,
    private translationService: TranslationService,
  ) {}

  getProductCrossReference(code: string, searchType: string): Observable<ProductReferencesStatusRequest> {
    const url = this.occEndPointService.buildUrl('productCrossReference', {
      urlParams: {
        code,
        searchType,
      },
    });

    return this.http.get(url).pipe(
      map((response: any) => {
        return {
          ...{
            products: response,
          },
          ...successStatus,
        };
      }),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            message: textError,
            ...failStatus,
          })),
        );
      }),
    );
  }
}
